<template>
  <Col :span="colSpan">
    <Modal v-model="modalsh" title="切换玩法开关" @on-ok="postbtn">
      <h2>
        是否将玩法：
        <b class="pc1 mr-2">{{scname}}</b>进行切換？
      </h2>
    </Modal>
    <div class="left mr-2">停押 :</div>
    <div v-if="turnbtn.length">
      <span v-for="(it, index) in turnbtn" :key="index+'btn'">
        <button
          v-if="it.stopclass== 1"
          class="crbtn"
          @click="btntrun(it.stopclass, it.isstop, it.scname)"
        >
          <a class="restopclass" :class="it.isstop == 1 ? 'pc3' : 'pc1'">{{ it.scname }}</a>
        </button>
        <button v-else-if="it.cou" class="crbtn" @click="btntrun('0', it.cou != 0 ? 1 : 2, '非特码')">
          <a :class="it.cou != 0 ? 'pc3' : 'pc1'" class="restopclass">非特码</a>
          <!-- <a v-else class="restopclass pc3">非特码</a> -->
        </button>

        <span v-else>
          <a
            v-if="turnbtnle == index"
            :class="it.isstop == 1 ? 'pc3' : 'pc1'"
            @click="btntrun(it.stopclass,it.isstop,it.scname)"
          >{{ it.scname }}</a>
          <a
            v-else
            :class="it.isstop == 1 ? 'pc3' : 'pc1'"
            class="restopclass"
            @click="btntrun(it.stopclass,it.isstop,it.scname)"
          >{{ it.scname }},</a>
        </span>
      </span>
    </div>
  </Col>
</template>

<script>
import { mapGetters } from "vuex";
import { log } from 'util';
export default {
  data () {
    return {
      turnbtn: [],
      turnbtnle: 0,
      btnSliceArry: {
        '1': [],
        '2': [2],
        '3': [3],
        '4': [4],
        '5': [5],
        '6': [6],
        '7': [7],
        '8': [8],
        '9': [17, 18, 19, 15, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63],
        '10': [9, 10, 11, 12, 13],
        '11': [26, 27, 28, 29, 30, 31, 32, 33],
        '12': [34, 35, 36, 37, 38, 39],
        '13': [20, 21, 22, 23, 24, 25],
        '14': [40, 41, 42, 43, 44, 45],
        '15': [46, 47, 48, 49, 50],
        '16': [16, 51, 52, 14]
      },
      modalsh: false,
      stopclass: '',
      newvalue: '',
      scname: ''
    }
  },
  created () {
    // this.firstread()
  },
  computed: {
    ...mapGetters(["getmember", "getpermission", "getgameid"]),
    colSpan () {
      const state = ['9', '11', '12', '16'].some(it => it == this.$route.meta.page)
      return state ? 7 : 4
    }
  },
  watch: {
    '$route': 'firstread'
  },
  methods: {
    firstread () {
      // this.$axios.liveshow.stopclname(this.getgameid).then(res => {
      //   if (this.$route.meta.page in this.btnSliceArry) {
      //     this.turnbtn = []
      //     let data = this.btnSliceArry[this.$route.meta.page]
      //     this.turnbtn.push(res[0], res[1])
      //     data.forEach(val => {
      //       this.turnbtn.push(res[val])
      //     })
      //   }
      //   this.turnbtnle = this.turnbtn.length - 1
      // });
    },
    btntrun (stopclass, isstop, scname) {
      this.modalsh = true;
      this.stopclass = stopclass
      this.scname = scname
      isstop == 1 ? this.newvalue = 2 : this.newvalue = 1
    },
    postbtn () {
      var data = { loid: this.getmember.pid, stopclass: this.stopclass, newvalue: this.newvalue };
      this.$axios.liveshow.stopclnamepost(this.getgameid, data).then(res => {
        if (res.status == 1) {
          this.$Message.success('已变更');
        } else {
          this.$Message.error('变更失败');
        }
        this.firstread();
      });
    }
  }
}
</script>

